import { css } from "@emotion/react";
import React, { useState, useEffect } from "react";

const dummyImageData = [
  "https://img.freepik.com/premium-photo/close-up-shot-dandelion_328046-24434.jpg",
  "https://www.chelseagreen.com/wp-content/uploads/bb-plugin/cache/A-Forest-in-the-Desert-Medium-Quality-panorama-0681ad4a3540a212f67a1c536a8cd871-5a8351871d42d.jpg",
  "https://media.istockphoto.com/id/185634807/photo/poplar.jpg?s=612x612&w=is&k=20&c=auioMRcaR7mE3xy9tmkqLXzK3MBZQkJ-Zi9abNEXiW4=",
  "https://images.unsplash.com/photo-1448375240586-882707db888b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxleHBsb3JlLWZlZWR8MXx8fGVufDB8fHx8fA%3D%3D&w=1000&q=80",
  "https://img.freepik.com/premium-photo/dark-forest-misterious-mist-autumn-morning_158217-3717.jpg",
  "https://us.123rf.com/450wm/photomaru/photomaru2210/photomaru221000054/192914222-deep-in-fairy-tale-forest-dark-spooky-trees-silhouettes-along-a-misty-path-3d-digital-illustration.jpg?ver=6",
  "https://cdn.pixabay.com/photo/2018/08/14/13/23/ocean-3605547_640.jpg",
  "https://images.unsplash.com/photo-1597697503794-1b84c3f8796b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDE0fHx8ZW58MHx8fHx8&w=1000&q=80",
  "https://media.istockphoto.com/id/1443530946/photo/noche-en-la-naturaleza.jpg?s=612x612&w=0&k=20&c=IRfXD2MgmTrGAJ8CplFUmKLOQA-sojG8IUCUXjLDCOw=",
];
const dummyTextData = [
  "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus tortor, dignissim sit amet, adipiscing nec, ultricies sed, dolor. Cras elementum ultrices diam.",
  "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus tortor, dignissim sit amet, adipiscing nec, ultricies sed, dolor. Cras elementum ultrices diam.",
  "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus tortor, dignissim sit amet, adipiscing nec, ultricies sed, dolor. Cras elementum ultrices diam.",
  "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus tortor, dignissim sit amet, adipiscing nec, ultricies sed, dolor. Cras elementum ultrices diam.",
  "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus tortor, dignissim sit amet, adipiscing nec, ultricies sed, dolor. Cras elementum ultrices diam.",
  "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus tortor, dignissim sit amet, adipiscing nec, ultricies sed, dolor. Cras elementum ultrices diam.",
  "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus tortor, dignissim sit amet, adipiscing nec, ultricies sed, dolor. Cras elementum ultrices diam.",
  "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus tortor, dignissim sit amet, adipiscing nec, ultricies sed, dolor. Cras elementum ultrices diam.",
  "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus tortor, dignissim sit amet, adipiscing nec, ultricies sed, dolor. Cras elementum ultrices diam.",
];

interface Props {
  imageData?: string[];
  textData?: string[];
  imageWidth?: number;
  color?: string;
}

const GImagePop: React.FC<Props> = (props) => {
  const [mouseX, setMouseX] = useState(-1000);
  const [mouseY, setMouseY] = useState(-1000);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [containerStyles, setContainerStyles] = useState<{
    [key: string]: string;
  }>({});

  const styles = css`
    * {
      margin: 0;
    }

    width: 100%;
    height: 100%;
    overflow: hidden;
    background: rgba(10, 10, 10);
    position: relative;

    .content-container {
      width: ${props.imageWidth}px;
      position: absolute;
      transform: translate(-50%, -50%);
      opacity: 0;
      transition: opacity 0.3s;
    }
    .content-container > .image {
      width: 100%;
    }

    .content-container .text-container {
      position: absolute;
      visibility: hidden;
      opacity: 0;
      font-size: 18px;
      transform: translateY(30px);
      padding: 0px 15px;
      color: ${props.color};
    }
    .text-container .text-heading {
      font-weight: bold;
      margin-right: 5px;
    }

    .content-container:hover .text-container {
      animation: slideIn 0.2s ease-in forwards;
      animation-delay: 0.6s;
    }

    .content-container[data-status="inactive"] {
      animation: hide 0.2s linear forwards;
    }
    .content-container[data-status="active"] {
      // display: block;
      animation: fadeIn 0.6s ease-out;
    }

    @keyframes fadeIn {
      0% {
        opacity: 0;
        transform: translate(-50%, -50%) scale(-0.2) rotate(-7deg);
      }
      100% {
        opacity: 1;
        transform: translate(-50%, -50%) scale(1) rotate(0);
      }
    }
    @keyframes slideIn {
      100% {
        transform: translateY(0px);
        opacity: 1;
        visibility: visible;
      }
    }
    @keyframes hide {
      100% {
        transform: translate(-50%, -50%) scale(0.2);
        opacity: 0;
        visibility: hidden;
      }
    }

    ${Object.keys(containerStyles).map((key: string) => {
      const property = `.${key} { ${containerStyles[key]} }`;
      return property;
    })}
  `;

  /* taking care of styles */
  useEffect(() => {
    const copy: { [key: string]: string } = { ...containerStyles };
    copy[
      `content-container[data-index="${currentIndex}"]`
    ] = `top: ${mouseY}px; left: ${mouseX}px; opacity: 1 `;

    setContainerStyles(copy);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentIndex]);

  /* hiding all the images except last 4 */
  useEffect(() => {
    if (!props.imageData) return;
    const getElement = (index: string | number) =>
      document.querySelector(
        `.content-container[data-index="${index}"]`
      ) as HTMLElement;

    const tail =
      currentIndex - 4 >= 0
        ? currentIndex - 4
        : props.imageData.length + currentIndex - 4;

    const element = getElement(tail);

    if (element) {
      element.setAttribute("data-status", "inactive");
    }

    const currentElement = getElement(currentIndex);
    if (currentElement) {
      currentElement.setAttribute("data-status", "active");
    }
  }, [currentIndex]);

  /* hiding all except the last one (current index) */
  useEffect(() => {
    return;
    const allElements = document.querySelectorAll(
      `.content-container[data-status="active"]`
    );

    allElements &&
      Array.from(allElements).map((element) => {
        const dataIndex = parseInt(`${element.getAttribute("data-index")}`);
        console.log("currentIndex", currentIndex, "dataIndex", dataIndex);

        if (dataIndex !== currentIndex) {
          setTimeout(() => {
            element.setAttribute("data-status", "inactive");
          }, 1000);
        }
      });
  }, [currentIndex]);

  const distanceFromLast = (x: number, y: number) => {
    return Math.hypot(x - mouseX, y - mouseY);
  };

  const mouseMoveHandler = (e: React.MouseEvent<HTMLElement>) => {
    if (!props.imageData || !props.imageWidth) return;
    if (distanceFromLast(e.clientX, e.clientY) > props.imageWidth / 2) {
      setMouseX(e.clientX);
      setMouseY(e.clientY);

      const index =
        currentIndex === props.imageData.length - 1 ? 0 : currentIndex + 1;
      setCurrentIndex(index);
    }
  };

  return (
    <div css={styles} onMouseMove={mouseMoveHandler}>
      {props.imageData?.map((item, i) => {
        return (
          <div
            key={i}
            data-status="inactive"
            data-index={i}
            className="content-container"
            style={{ zIndex: i === currentIndex ? "99" : "" }}
          >
            <img className="image" src={item} />

            <div className="text-container">
              <p>
                {/* <span className="text-heading">{item.heading}.</span>{" "} */}
                {props.textData && props.textData[i]}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

GImagePop.defaultProps = {
  imageData: dummyImageData,
  textData: dummyTextData,
  imageWidth: 300,
  color: "#fff",
};

export default GImagePop;

/*
addPropertyControls(GImagePop, {
    imageData: {
        title: "Images",
        type: ControlType.Array,
        propertyControl: {
            type: ControlType.Image,
            title: "Image",
        },
    },
    textData: {
        title: "Text",
        type: ControlType.Array,
        propertyControl: {
            type: ControlType.String,
            title: "Text",
        },
    },
    imageWidth: {
        title: "Image Width",
        type: ControlType.Number,
        defaultValue: 300,
    },
    color: {
        title: "Color",
        type: ControlType.Color,
        defaultValue: "#fff",
    },
    letterSpacing: {
        title: "Letter",
        type: ControlType.Number,
    },
    fontSize: {
        title: "Font Size",
        type: ControlType.Number,
        defaultValue: 46,
    },
    fontFamily: {
        title: "Font Family",
        type: ControlType.Font,
        defaultValue: "Sigmar",
    },
})

*/
